/**
 * Copyright (c) 2019-2022 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __awaiter, __generator } from "tslib";
import { pdbToMmCif } from './pdb/to-cif';
import { Task } from '../../mol-task';
import { MmcifFormat } from './mmcif';
import { createModels } from './basic/parser';
import { Column } from '../../mol-data/db';
import { AtomPartialCharge } from './property/partial-charge';
import { createBasic } from './basic/schema';
export { PdbFormat };
var PdbFormat;
(function (PdbFormat) {
    function is(x) {
        return (x === null || x === void 0 ? void 0 : x.kind) === 'pdb';
    }
    PdbFormat.is = is;
    function create(pdb) {
        return { kind: 'pdb', name: pdb.id || '', data: pdb };
    }
    PdbFormat.create = create;
})(PdbFormat || (PdbFormat = {}));
export function trajectoryFromPDB(pdb) {
    var _this = this;
    return Task.create('Parse PDB', function (ctx) { return __awaiter(_this, void 0, void 0, function () {
        var cif, format, basic, models, partial_charge, first, srcIndex, isIdentity, srcIndexArray, q_1, partialCharge;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ctx.update('Converting to mmCIF')];
                case 1:
                    _b.sent();
                    return [4 /*yield*/, pdbToMmCif(pdb)];
                case 2:
                    cif = _b.sent();
                    format = MmcifFormat.fromFrame(cif, undefined, PdbFormat.create(pdb));
                    basic = createBasic(format.data.db, true);
                    return [4 /*yield*/, createModels(basic, format, ctx)];
                case 3:
                    models = _b.sent();
                    partial_charge = (_a = cif.categories['atom_site']) === null || _a === void 0 ? void 0 : _a.getField('partial_charge');
                    if (partial_charge) {
                        // TODO works only for single, unsorted model, to work generally
                        //      would need to do model splitting again
                        if (models.frameCount === 1) {
                            first = models.representative;
                            srcIndex = first.atomicHierarchy.atomSourceIndex;
                            isIdentity = Column.isIdentity(srcIndex);
                            srcIndexArray = isIdentity ? void 0 : srcIndex.toArray({ array: Int32Array });
                            q_1 = partial_charge.toFloatArray();
                            partialCharge = srcIndexArray
                                ? Column.ofFloatArray(Column.mapToArray(srcIndex, function (i) { return q_1[i]; }, Float32Array))
                                : Column.ofFloatArray(q_1);
                            AtomPartialCharge.Provider.set(first, {
                                data: partialCharge,
                                type: 'GASTEIGER' // from PDBQT
                            });
                        }
                    }
                    return [2 /*return*/, models];
            }
        });
    }); });
}
